<template>
  <IndicatorWrapper class="sectors-ranking" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters
        ref="textComponent"
        textKey="sectors_ranking_text_with_filters"
        :textData="dynamicTextData"
        v-model="currentFilters"
      ></TextWithFilters>
    </div>
    <div class="bottom">
      <RankingChart :data="indicatorData.evolutive" :compareData="indicatorData.compare_data" :status="evolutiveStatus" @changeSelection="currentSelection = $event"></RankingChart>
      <ChartLegend :items="legendItems" v-show="isCompareMode"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="sectors_ranking_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indDynamicText from '@/mixins/indDynamicText'
import indData from '@/mixins/indData'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import RankingChart from '@/components/IndicatorCards/parts/charts/RankingChart'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'
import {capitalize} from '@/utils/textUtils'

export default {
  name: 'SectorsRanking',
  mixins: [indData, indDynamicText],
  components: {
    TextWithFilters,
    RankingChart,
    ChartLegend,
    IndicatorWrapper,
    ChartDescription,
    ChartLegend
  },
  data () {
    return {
      currentSelection: null
    }
  },
  computed:{
    indicatorData() {
      return {
        evolutive: {
          required: true,
          get () {
            return Api.getIndicatorData('evol_sector_ranking_month',this.currentFilters)
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('evol_sector_ranking_month',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        }
      }
    }, 
    dynamicTextData () {
      let month = this.currentSelection && new Date(this.currentSelection.value).toLocaleString('es-ES',{ month: 'long' })
      if(!month) month = '-'
      //month = month.charAt(0).toUpperCase() + month.slice(1)

      let currentData = this.currentSelection && Array.from(this.currentSelection.data)
      let topSector
      if(currentData) {
        currentData.sort((a,b) => b.value - a.value)
        topSector = currentData[0]
      }
      return [
        {
          type: 'value',
          id: 'VALUE_MONTH',
          value: capitalize(month)
        },
        {
          type: 'value',
          id: 'SECTOR_NAME',
          value: topSector ? this.t(topSector.id) : '--'
        },
        {
          type: 'value',
          id: 'SECTOR_VALUE',
          value: topSector ? topSector.value : '--',
          unit: '%'
        },
      ]
    },
    evolutiveStatus () {
      // return (!this.indicatorData['evolutive'] || this.$asyncComputed['asc_evolutive'].updating) ? {status:'fetching'} : {status:'ready'}
      if(this.$asyncComputed['asc_evolutive'].updating) return {status:'fetching'}
      else if(!this.indicatorData['evolutive']) return {status:'no-data'}
      else return {status:'ready'}
    },
  },
  
}
</script>

<style lang="stylus">
.sectors-ranking
  .bottom
    .desktop &
      margin-top: vh(-80px)
</style>
<style lang="stylus" scoped>
  .ranking-chart
    .mobile &
      flex 1 0 vh(360px)

</style>